import VModal from '@/vuetify_custom/v-modal_v1'
import VForm from '@/vuetify_custom/v-form'
import {mapGetters} from "vuex";
import ReceiptFiveSelectMixins from '@/views/fin_bill/mixins/receipt_five_select_mixins.js'
import {postgetOutsourceContractTitleMappingApi} from './service'
const d = val => !!val || '必选'
const createParams = () => ({
    "id": null,
    "job_content": null,
    "customer_function_id": null,
    "quantitative_output":false,
    "account_title_id":null,
    "analysis_title_id":null,
})
const change_fields = [
    'customer_function_id', 
    'expense_nature_id', 
   
    'customer_type', // 员工类型
    'item_type_id',
    'fund_usage_id',
]
export default {
    mixins:[ReceiptFiveSelectMixins],
    data() {
        return {
            show:false,
            loading:false,
            expense:createParams(),
            expect_finish_date: null,
            change_fields: change_fields
        }
    },
    computed: {
        ...mapGetters('async', [
            'customer_functions'
          ]),
          finacer_fields() {
            
            return [
                // this.cost_nature_field, // 费用nature
                // this.customer_types_field, // 员工类型
                // this.item_type_field, // 产品类型
                // this.fund_usage_field, // 费用用途
                // this.insider_trading_field, // 是否是内部交易
                {
                    ...this.account_title_field_readonly,
                    readonly: false,
                }, // 会计科目
                {
                    ...this.analysis_title_field_readonly,
                    readonly: false,
                }, // 分析科目
            ]
          },
        fields() {
            return [
                {
                    label: '工作内容',
                    type: 'select_field',
                    key: 'job_content',
                    'item-text': 'label',
                    'item-value': 'label',
                    cols: 12,
                    required: true,
                    items:[
                        {
                            label: '内容创作',
                          
                        },
                        {
                            label: '咨询服务',
                            
                        },
                        {
                            label: '广告推广',
                           
                        }
                    ],
                    rules: [d]
                },
                {
                    ...this.customer_function_field,
                    required: true,
                    cols: 12,
                    disabled: false,
                    rules:[d]
                }, // 员工职能
                {
                    label: '是否量产',
                    key:'quantitative_output',
                    type: 'checkbox',
                },
                ...this.finacer_fields.map(i => {
                    i.cols = 12
                    return i
                })
            ]
        }
    },
    methods: {
        edit(data) {
            const y = createParams()
       if (data) {
        Object.keys(y).forEach(key => {
            y[key] = data[key]
        })    
       } 
       this.expense = y
            this.show = true
      
            setTimeout(() => {
                this.$refs.form && this.$refs.form.resetValidation()
            }, 50)
        },
        submit() {
            if (this.$refs.form.validate()) {
                this.loading = true
                postgetOutsourceContractTitleMappingApi(this.expense).then(() => {
                    this.$Message.success('数据提交成功！')
                    this.$emit('success')
                    this.show = false
                }).finally(() => {
                    this.loading = false
                })
     
            }
        }
    },
    render() {
        return <VModal
        v-model={this.show}
        dynamicHeight
        heightRate={0.9}
        title={this.expense.id ? '编辑' : '新增'}
        loading={this.loading}
        width={800}
        ref="modal"
        ok-text="保存"
        on={{
            ok: () => {
                this.submit() 
            },
        }}
        >
            <VForm 
                ref="form" 
                fields={this.fields} 
                v-model={this.expense}
                
            />
        </VModal>
    }
}